if(!customElements.get('osz-home-d'))customElements.define('osz-home-d',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    const options={signal:this.controller.signal};
    this.panels=Array.from(this.querySelectorAll('[data-d-panel]'));
    this.index=0;this.request=0;this.themeRequest=0;
    this.controls=this.querySelector('.d-controls');
    this.classList.add('is-ready');this.controls.hidden=false;
    this.querySelectorAll('[data-d-product]').forEach(button=>button.hidden=false);
    this.controls.addEventListener('click',event=>{
      const button=event.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-d-theme'))this.show(this.panels.findIndex(panel=>panel.dataset.dPanel===button.dataset.dTheme));
      else if(button.hasAttribute('data-d-next'))this.show(this.index+1);
      else if(button.hasAttribute('data-d-prev'))this.show(this.index-1);
    },options);
    this.addEventListener('click',event=>{const button=event.target.closest('[data-d-product]');if(button)this.select(button);},options);
    this.controls.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.show(this.index+(event.key==='ArrowLeft'?-1:1));}},options);
    this.themeMessage=this.querySelector('.d-theme-message');
    this.querySelectorAll('.d-scene').forEach(image=>image.addEventListener('error',()=>{if(!image.closest('[data-d-panel]').hidden)this.themeMessage.textContent=this.themeMessage.dataset.initialError;},options));
    this.panels.forEach((panel,i)=>panel.hidden=i!==0);
    const firstScene=this.panels[0].querySelector('.d-scene');if(firstScene?.complete&&!firstScene.naturalWidth)this.themeMessage.textContent=this.themeMessage.dataset.initialError;
    this.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'&&event.target.closest('.d-panorama'))this.swipe={x:event.clientX,y:event.clientY,id:event.pointerId};},options);
    this.addEventListener('pointerup',event=>{const start=this.swipe;this.swipe=null;if(!start||event.pointerId!==start.id)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;if(Math.abs(dx)>=50&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1));},options);
    this.addEventListener('pointercancel',()=>{this.swipe=null;},options);
    this.show(0);
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.request++;}
  show(index){
    if(index<0)index=this.panels.length-1;
    const next=index%this.panels.length,panel=this.panels[next],request=++this.themeRequest;
    this.request++;
    const commit=()=>{
      if(request!==this.themeRequest)return;
      this.index=next;this.themeMessage.textContent='';
      this.panels.forEach((item,i)=>{item.hidden=i!==next;});
      this.controls.querySelectorAll('[data-d-theme]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.dTheme===panel.dataset.dPanel)));
      panel.querySelectorAll('img[loading="lazy"]').forEach(image=>{image.loading='eager';});
      const first=panel.querySelector('[data-d-product]');if(first)this.select(first);
    };
    const scene=panel.querySelector('.d-scene');
    if(!scene){commit();return;}
    const image=new Image();image.onload=commit;
    image.onerror=()=>{if(request===this.themeRequest)this.themeMessage.textContent=next===this.index?this.themeMessage.dataset.initialError:this.themeMessage.dataset.sceneError;};
    image.src=scene.currentSrc||scene.src;
  }
  select(button){
    const panel=button.closest('[data-d-panel]'),stage=panel.querySelector('.d-stage'),message=panel.querySelector('.d-message');
    const request=++this.request,image=new Image();message.textContent='';
    image.onload=()=>{
      if(request!==this.request)return;
      const picture=stage.querySelector('img');picture.removeAttribute('srcset');picture.removeAttribute('sizes');picture.src=button.dataset.image;picture.alt=button.dataset.title;
      stage.querySelector('.d-product-title').textContent=button.dataset.title;
      const photo=stage.querySelector('.d-stage-photo');photo.href=button.dataset.url;photo.setAttribute('aria-label',button.getAttribute('aria-label').replace(/^Preview /,'View ')+' details');
      stage.querySelector('.d-product-link').href=button.dataset.url;
      stage.dataset.productId=button.closest('.d-choice').dataset.productId;
      panel.querySelectorAll('[data-d-product]').forEach(item=>{const active=item===button;item.setAttribute('aria-pressed',String(active));item.closest('.d-choice').classList.toggle('selected',active);});
      stage.classList.remove('changing');void stage.offsetWidth;stage.classList.add('changing');
    };
    image.onerror=()=>{if(request===this.request)message.textContent=message.dataset.error;};
    image.src=button.dataset.image;
  }
});
